import { UserModel } from '@/typings/models/User';
import moment from 'moment';
import { ROUTE_PATHS } from '../../config/RoutePaths';

export function getUserWorkingHours(user: UserModel) {
  return user?.availability?.working_hours;
}

export function getUserOffPeriods(user: UserModel) {
  return user?.availability?.off_days || [];
}

export function getUserAdditionalPeriods(user: UserModel) {
  return (user?.availability?.extra_days || []).map((period) => ({
    start: moment(period.date, 'YYYY-MM-DD').hour(period.start.split(':')[0]).minute(period.start.split(':')[1]),
    end: moment(period.date, 'YYYY-MM-DD').hour(period.end.split(':')[0]).minute(period.end.split(':')[1]),
  }));
}


/**
 * The timezones a person's availability applies in: the local time of every
 * branch they provide a service in (CalKit evaluates the wall-clock working
 * hours in the booked calendar's timezone, i.e. the branch's). Unique, sorted;
 * empty when the person serves no branch.
 */
export function getAgentBranchTimezones(
  agent?: { services?: ({ branch?: { timezone?: string | null } | null } | null)[] | null } | null,
): string[] {
  const timezones = (agent?.services || [])
    .map((service) => service?.branch?.timezone)
    .filter((timezone): timezone is string => !!timezone);
  return Array.from(new Set(timezones)).sort();
}

const USER_DETAILS_PATH = /^\/users\/[^/]+\/?$/;

/**
 * Where closing the employee drawer leads. Opened from a /users/:id link there is no page
 * behind it, and keeping that URL would reopen the drawer on every reload or bookmark.
 */
export function getUserDrawerReturnPath(previousPath: string, canOpenUserList: boolean): string {
  if (!USER_DETAILS_PATH.test(previousPath)) return previousPath;
  return canOpenUserList ? ROUTE_PATHS.ORGANIZATION_USER : '/';
}
